export type GamesListType = {
    id: number;
    image: string;
    title: string;
    googleStoreUrl: string;
    appleUrl: string;
}

export const GameList: GamesListType[] = [
    {
        id: 1,
        image: "https://play-lh.googleusercontent.com/kgdLktLxIujlk3KSSd8gqj3tEniTNCiUbURdG-_aFK2kEzUOH-JA6CAo2cvsTNQH5Q=s180-rw",
        title: "Guess the Flag - World Flags Quiz, Trivia Game",
        googleStoreUrl: "https://play.google.com/store/apps/details?id=com.YaoLabs.FlagsOfTheWorldQuiz",
        appleUrl: "https://apps.apple.com/us/app/guess-the-flag-flags-quiz/id1559606777"
    },
    {
        id: 2,
        image: "https://play-lh.googleusercontent.com/8knefGMUit-WT3CWdnAqlBe-vK_skzmaIoAr_3VFzqO9e7jLZTDYXW-2ekez-Ki6vA=s180-rw",
        title: "Jigsaw Puzzles - Manga Puzzle Game",
        googleStoreUrl: "https://play.google.com/store/apps/details?id=com.yaolabs.mangapuzzle",
        appleUrl: "https://apps.apple.com/us/app/manga-jigsaw-puzzle/id1558421477"
    },
    {
        id: 3,
        image: "https://play-lh.googleusercontent.com/J-iZC8V_4MRJL0Tl26GqjHokgjQDQn8qB4cN-tCyqHd_fItU949UaS-doXMxAfZY5NY=s180-rw",
        title: "Emoji Brain Test: Tricky Puzzles",
        googleStoreUrl: "https://play.google.com/store/apps/details?id=com.EmojiStacks.EmojiStacks",
        appleUrl: "https://apps.apple.com/us/app/emoji-brain-test/id1554664018"
    },
    {
        id: 4,
        image: "https://play-lh.googleusercontent.com/8IFd57dutnahDHTPIROTy1LZkeIIplgXmilJgNvra1yiBldyRp5i_Aym7dri9cv4Tg=s180-rw",
        title: "Pairs Champion - The fastest matching game",
        googleStoreUrl: "https://play.google.com/store/apps/details?id=com.yaolabs.matchchamp",
        appleUrl: "https://apps.apple.com/us/app/%D7%90%D7%9C%D7%95%D7%A3-%D7%94%D7%94%D7%AA%D7%90%D7%9E%D7%95%D7%AA-%D7%9E%D7%A9%D7%97%D7%A7-%D7%94%D7%96%D7%95%D7%92%D7%95%D7%AA/id1548714736"
    }
]

export const GooglePlayStoreLink = "https://play.google.com/store/apps/dev?id=7153553500325068431";
